<template lang="pug">
  include /mixins
  +b.ds-panel--space_lg.--space_sm-xl
    +e.element--offset_horizontal

      template(v-for='parent in filter.attribute.values')
        template(v-if='!parent.props.depth')
          ui-accordion(
            :init='!!findChecked(parent.props)'
            :options='parent'
            :is-calculate-height='false'
          )
            template(#default='{ activeState, toggleActive, collapse }')
              +b.tt-accordion.tt-space_mt--4(
              )
                +e.question.--indent_none.--spaced_bottom-none.--clear-all
                  +e.text
                    +b.tt-link.--appearance_hovered.--black.variant_start.ds-caption--size_sm.--regular.A(
                      @click.prevent='!(isAvailable(parent.id, parent.label)) ? false : goTo(parent.props.label)'
                      :class='{"is-blocked": !(isAvailable(parent.id, parent.label))}'
                    ) {{ parent.props.title }}
                  +e.icon.mdi.I(
                    v-if='checkIsParent(parent.id)'
                    :class='[{"is-blocked": !(isAvailable(parent.id, parent.label))}, activeState ? "mdi-minus" : "mdi-plus" ]'
                    @click='toggleActive()',
                  )
                +e.description(
                  v-if="activeState"
                )
                  template(v-for='child in filter.attribute.values')
                    ui-accordion(
                      :init='false'
                      v-if='parent.id === child.props.parent'
                      :is-calculate-height='false'
                    )
                      template(#default='{ activeState, toggleActive, collapse }')
                        +b.tt-accordion.tt-space_mt--3(
                        )
                          +e.question.--indent_none.--spaced_bottom-none.--clear-all
                            +e.text
                              +b.d-control-input.--appearance_flexible(
                                :style='{"margin-left": `${getSpace(child.props.depth)}px`}'
                              )
                                +e.element.INPUT(
                                  type='checkbox'
                                  :value='child.props.label',
                                  :name='filter.attribute.label'
                                  v-model='checked'
                                  :input-label='child.props.title',
                                  :id='`${filter.attribute.label}:${child.id}`'
                                  @change='clearParent(parent);submit()'
                                  :disabled='!isAvailable(child.id, child.label)'
                                )
                                +e.LABEL.label--for-checkbox(
                                  :class='{"d-control-input__label--spaced": checkIsParent(child.id)}'
                                  :for='`${filter.attribute.label}:${child.id}`'
                                )
                                  // span(style='color: red') {{ !isAvailable(child.id, child.label) }}  {{ child.id }}
                                  tag.fake-link(
                                    :key='`tag_${child.props.label}`'
                                    :tag='url(child.props.label, child.props.id) ? "a" : "span"'
                                    :href='url(child.props.label, child.props.id)'
                                  ) {{ child.props.title }}
                                  //-  #[b(style='font-size: 10px') {{ url(child.props.label, child.id) }}]
                                // for available filters debug

                            +e.icon.mdi.I(
                              v-if='checkIsParent(child.id)'
                              :class='activeState ? "mdi-minus" : "mdi-plus"'
                              @click='toggleActive()',
                            )
                          +e.description(
                            v-if="activeState"
                          )
                            template(v-for='lastChild in filter.attribute.values')
                              +b.tt-space_mt--3(
                                v-if='child.id === lastChild.props.parent'
                              )
                                +b.d-control-input.--variant_child.--appearance_flexible(
                                  :style='{"margin-left": `${getSpace(lastChild.props.depth)}px`}'
                                )
                                  +e.element.INPUT(
                                    type='checkbox'
                                    :value='lastChild.props.label',
                                    :name='filter.attribute.label'
                                    v-model='checked'
                                    :input-label='lastChild.props.title',
                                    :id='`${filter.attribute.label}:${lastChild.id}`'
                                    @change='clearParent(child);submit()'
                                    :disabled='!isAvailable(lastChild.id, lastChild.label)'
                                  )
                                  +e.LABEL.label--for-checkbox.--spaced(
                                    :for='`${filter.attribute.label}:${lastChild.id}`'
                                  )
                                    // span(style='color: red') {{ !isAvailable(lastChild.id, lastChild.label) }}  {{ lastChild.id }}
                                    tag.fake-link(
                                      :key='`tag_${lastChild.props.label}`'
                                      :tag='url(lastChild.props.label, lastChild.props.id) ? "a" : "span"'
                                      :href='url(lastChild.props.label, lastChild.props.id)'
                                    ) {{ lastChild.props.title }}
                                    //-  #[b {{ url(lastChild.props.label, lastChild.id) }}]
                                  // for available filters debug

</template>
<script>

import { outstand } from '@utils/helpers'
import urlGeneratorMixin from './urlGenerator'

const DEPTH_SPACE = {
  1: 0,
  2: 24,
}

const FILTER_LABEL_MAP = {
  category: 'categories',
}

export default {
  name: 'SimpleCategoryWidget',
  props: ['value', 'filter', 'available', 'customCheck', 'label', 'all', 'baseUrl'],
  mixins: [urlGeneratorMixin],
  data() {
    return {
      checked: [],
    }
  },
  computed: {
    categoriesFilter() {
      return this.customCheck && this.label && !this.value
    },
    parentsLabels() {
      return this.filter.attribute.values.filter(e => !e.props.depth).map(e => e.props.label)
    },
  },
  watch: {
    value(nval) {
      this.checked = this.normalize(nval)
    },
  },
  mounted() {
    this.checked = this.normalize(this.value)
  },
  methods: {
    outstand,
    goTo(label) {
      window.location.href = `${this.baseUrl}${label}/`
    },
    submit() {
      this.checked = this.checked.filter(e => !this.parentsLabels.find(l => l == e))
      // if (this.categoriesFilter) this.$emit('category-hack', 'category')
      this.$nextTick(() => {
        this.$emit('input', this.checked)
      })
    },
    clearParent(parent) {
      this.checked = this.checked.filter(e => e !== parent.props.label)
    },
    hasActive(val) {
      return this.checked.includes(val)
    },
    isAvailable(id, label) {
      if (!this.available.attributes) return true
      const customLabel = FILTER_LABEL_MAP[this.filter.attribute.label] || this.filter.attribute.label
      const customFilter = this.available[customLabel]
      if (customFilter) {
        const a = customFilter.find(el => el == id)
        if (!a && this.hasActive(label)) return true
        return a
      }
      const a = this.available.attributes.find(el => el == id)
      if (!a && this.hasActive(label)) return true
      return a
    },
    findChecked({ label, id }) {
      const children = this.filter.attribute.values.filter(el => el.props.parent === id).map(e => e.props.label)
      return this.checked.includes(label) || children.find(l => this.checked.includes(l))
    },
    checkIsParent(id) {
      const children = this.filter.attribute.values.filter(el => id === el.props.parent)
      return children.length
    },
    custom() {
      const [l] = this.label.split('/')
      const checked = this.filter.attribute.values.filter(el => l === el.props.label).map(el => el.props.label)
      return checked
    },
    getSpace(depth) {
      return DEPTH_SPACE[depth]
    },
    normalize(value) {
      if (this.categoriesFilter) {
        return this.custom()
      }
      if (!value) return []
      const checked = this.filter.attribute.values.filter(el => value.find(v => v == el.props.label)).map(el => el.props.label)
      return checked
    },
  },
}
</script>
